export default "__VITE_ASSET__52ccb19d__"